import React, { useEffect, useState } from "react";
import { tableProps } from "../../../../../../styles/muiProps";
import { MaterialReactTable } from "material-react-table";
import { columns2 } from "./columns";
import { ListItemIcon, MenuItem, Typography } from "@mui/material";

import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import DeleteIcon from "@mui/icons-material/Delete";
import { get5d } from "./api";
import { getPvHours } from "../FAbHours/api";
import { useParams } from "react-router-dom";
import { set } from "firebase/database";

const Project5d = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  // const [hoursData, setHoursData] = useState();
  useEffect(() => {
    console.log("hereeeessssseee", id);

    const getData = async () => {
      const data = await get5d(id).then((res) => {
        console.log("5d resssss", res);
        const filteredData = res.filter(
          (item) => item["Description"] !== "Total"
        );
        setData(filteredData);
        // setData(res);
      });
    };
    // const getHoursData = async () => {
    //   await getPvHours(id).then((res) => {
    //     console.log("hours resssssss", res);
    //     let data = {};
    //     res.forEach((item) => {
    //       console.log("item", item);

    //       if (data[item["Cost Code"]]) {
    //         data[item["Cost Code"]].totalManHours +=
    //           Number(item["Total Manhour"]) || 0;
    //         data[item["Cost Code"]].actual_hours +=
    //           Number(item["actualhours"]) || 0;
    //       } else {
    //         data[item["Cost Code"]] = { totalManHours: 0 };
    //         data[item["Cost Code"]].totalManHours +=
    //           Number(item["Total Manhour"]) || 0;
    //         data[item["Cost Code"]].actual_hours +=
    //           Number(item["actualhours"]) || 0;
    //       }
    //     });
    //     // console.log("hours dataaaaaaaaaaaaaaaaaa", data);

    //     setHoursData(data);
    //   });
    // };
    // getHoursData();
    getData();
  }, [id]);

  return (
    <MaterialReactTable
      // style={{ tableLayout: "auto" }}
      columns={columns2()}
      data={data || []}
      editDisplayMode="cell"
      // enableEditing={isEditTable}
      enableColumnActions={false}
      // enableRowActions
      positionActionsColumn="last"
      enableGrouping
      enableExpandAll
      initialState={{
        grouping: ["Cost Code "],
        expanded: false,
        pagination: { pageSize: 30 },
        columnVisibility: { Component: false },
      }}
      // enableColumnResizing={true}
      layoutMode={"grid"}
      {...tableProps}
      muiTableHeadCellProps={({ cell }) => ({
        sx: {
          borderRight: "1px solid rgba(224,224,224,1)",
          backgroundColor: "hsla(250, 86%, 97%, 1)",
          fontSize: "13px",
          pt: 2,
        },
      })}
      muiTableBodyCellProps={{
        sx: {
          padding: "8.5px 8px",
          // textAlign: "center",
          borderRight: "1px solid rgba(224,224,224,1)",
        },
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          size: 5,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
            sx: {
              p: 0,
              "& button": {
                ml: 0,
              },
            },
          },
        },
      }}
      // renderTopToolbarCustomActions={() => (
      //     <h4>Cost Comparison</h4>
      // )}
      defaultColumn={{
        minSize: 60, //allow columns to get smaller than default
        // maxSize: 160, //allow columns to get larger than default
        size: 80, //make columns wider by default
      }}
    />
  );
  // ) : (
  //   <>Loading</>
  // );
};

export default Project5d;
